export default {
   // user settings data 
   getSettings(state) {
      return state.settings;
   },

}